<template>
    <div class="flex w-full h-full broodmare-view justify-content-around">
        <LibyanOrnament vertical class="lib-or mr-5"/>
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.broodmareList.header') }}</h2>
            </div>
            <BroodmareTable ref="broodmareTable" />
        </div>
    </div>
</template>

<script>
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import BroodmareTable from "./components/BroodmareTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";

export default {
    name: "BroodmareListView",
    components: {
        CustomButton,
        BroodmareTable,
        LibyanOrnament,
    },

    data() {
        return {
        };
    },

    methods: {
        reloadTable() {
            this.$refs.broodmareTable.reloadTable();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/theme/mytheme/variables";
.broodmare-view {
    @media screen and (max-width: 750px) {
        .lib-or {
            display: none;
        }
    }
    @media screen and (max-width: 650px) {
        padding: 0 20px;
    }
}
</style>
